import { TFunction } from 'i18next'
import { ChatRoomStatus, MessageType, Platform, SenderType } from '../types'

export const ChatRoomStatusOptions = (t: TFunction) => [
    { label: t('Waiting'), value: 'waiting' as ChatRoomStatus },
    { label: t('In Progress'), value: 'in_progress' as ChatRoomStatus },
    { label: t('Done'), value: 'done' as ChatRoomStatus },
]

export const MessageTypeOptions = (t: TFunction) => [
    { label: t('Text'), value: 'text' as MessageType },
    { label: t('Image'), value: 'image' as MessageType },
    { label: t('Audio'), value: 'audio' as MessageType },
    { label: t('Video'), value: 'video' as MessageType },
    { label: t('File'), value: 'file' as MessageType },
    { label: t('Sticker'), value: 'sticker' as MessageType },
]

export const PlatformOptions = (t: TFunction) => [
    { label: t('Livechat'), value: 'livechat' as Platform },
    { label: t('Facebook'), value: 'facebook' as Platform },
]

export const SenderTypeOptions = (t: TFunction) => [
    { label: t('Agent'), value: 'agent' as SenderType },
    { label: t('Employee'), value: 'employee' as SenderType },
    { label: t('User'), value: 'user' as SenderType },
    { label: t('System'), value: 'system' as SenderType },
]

export const getChatRoomStatusColor = (status: ChatRoomStatus) => {
    switch (status) {
        case 'waiting':
            return 'warning'
        case 'in_progress':
            return 'info'
        case 'done':
            return 'success'
        default:
            return 'default'
    }
}

export const getSenderTypeColor = (sender: SenderType) => {
    switch (sender) {
        case 'agent':
            return 'info'
        case 'employee':
            return 'primary'
        case 'user':
            return 'default'
        case 'system':
            return 'secondary'
        default:
            return 'default'
    }
}

export const getPlatformColor = (platform: Platform) => {
    switch (platform) {
        case 'livechat':
            return 'primary'
        case 'facebook':
            return 'info'
        default:
            return 'default'
    }
}
